'use strict';

const LocalStorage = {
    setItem(key, value) {
        if (window.localStorage) {
            localStorage.setItem(key, value);
        }
    },
    getItem(key) {
        if (window.localStorage) {
            return localStorage.getItem(key);
        }
        return '';
    },
    
};

export default LocalStorage;
